export const buildSearch = ({ doctorName, city, q, speciality, secondarySpeciality, insurance, date }) => {
    const params = new URLSearchParams();

    if (doctorName) params.append('doctorName', doctorName);
    if (city) params.append('city', city);
    if (q) params.append('q', q);
    if (speciality) params.append('speciality', speciality);
    if (secondarySpeciality) params.append('secondarySpeciality', secondarySpeciality);
    if (insurance) params.append('insurance', insurance);
    if (date) params.append('date', date);

    const searchString = params.toString();
    return searchString ? `?${searchString}` : '';
};
